import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {PostAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class UploadFileForChatCommand<T> extends PostAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(
      apiService,
      adapter,
      `${environment.chatApiUrl}/messages/file-upload`,
    );
  }
}
